import { HeaderBase } from "../../shared/HeaderBase";
import logo from "../images/logo.svg";

export const Header = () => (
  <HeaderBase
    brand={
      <img
        src={logo}
        style={{
          height: 55,
          width: 167,
        }}
        alt="A.T.U"
      />
    }
  />
);
